var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadError)?_c('load-error'):_c('div',{staticClass:"ImageBox"},[_c('div',{staticClass:"ImageBox__content"},[_c('img',{style:(_vm.imageStyle),attrs:{"src":_vm.imgSrc,"alt":"","loading":"lazy"},on:{"error":_vm.onError,"load":_vm.onLoad}})]),_c('div',{staticClass:"swiper-lazy-preloader"})])
}
var staticRenderFns = []

export { render, staticRenderFns }